import { Check, Clipboard, Download, FileDown, FileText, Loader2, Share2 } from "lucide-react";
import DraftPreview from "../DraftPreview";
import { Button } from "@/components/ui/button";

export const DraftCard = ({
  result, shareCopied, copied, docxLoadingId, pdfLoadingId,
  onShare, onCopy, onDownloadMarkdown, onDocx, onPdf,
}) => (
  <div className="bg-white border border-slate-200 rounded-xl shadow-sm">
    <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-slate-100">
      <span className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">Draft · Markdown</span>
      <div className="flex gap-2">
        <Button type="button" variant="outline" size="sm" onClick={onShare} data-testid="research-share-btn">
          {shareCopied ? <Check className="w-4 h-4 mr-1.5" /> : <Share2 className="w-4 h-4 mr-1.5" />}{shareCopied ? "Link copied" : "Share"}
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={onCopy}>
          {copied ? <Check className="w-4 h-4 mr-1.5" /> : <Clipboard className="w-4 h-4 mr-1.5" />}{copied ? "Copied" : "Copy"}
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={onDownloadMarkdown}>
          <Download className="w-4 h-4 mr-1.5" />Markdown
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onDocx(result.project_id)}
          data-testid="research-download-docx"
        >
          {docxLoadingId === result.project_id ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <FileText className="w-4 h-4 mr-1.5" />}Word
        </Button>
        <Button
          type="button"
          size="sm"
          onClick={() => onPdf(result.project_id)}
          className="bg-orange-600 hover:bg-orange-700 text-white"
          data-testid="research-download-pdf"
        >
          {pdfLoadingId === result.project_id ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <FileDown className="w-4 h-4 mr-1.5" />}PDF
        </Button>
      </div>
    </div>
    <div className="p-6 sm:p-9"><DraftPreview markdown={result.draft_markdown} /></div>
  </div>
);
